import authorizedAPIInstance from '@/api/authorizedAPI';
import type {
  AssetSoftTagResponse,
  FetchSoftTagParams,
} from '../utils/match-maker.types';
import { formatAPIError } from '@/utils/helpers';

export const fetchSoftTagList = async (
  params?: FetchSoftTagParams
): Promise<AssetSoftTagResponse> => {
  try {
    const { data } = await authorizedAPIInstance.get<AssetSoftTagResponse>(
      `/api/timeseries`,
      {
        params: params || {},
      }
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
